export const initialState = {
  loading: false,
  targetTariff: null,
  targetTariffoptions: [],
  targetPromotions: [],
  volume: {
    amount: 0,
    promoAmount: 0,
    unit: null
  },
  limitedVolume: {
    promoAmount: 0,
    duration: 0,
    durationUnit: null,
    unit: null
  },
  price: {
    amount: 0
  },
  promoPrice: {
    promoAmount: 0,
    duration: 0,
    durationUnit: null
  },
  additionalPriceStairways: [],
  startingBonus: 0
}
